/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { WithStyles } from '@material-ui/core';
//use useParams
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash-es';
import { generateStyle } from '../../utils/styles';
import Style from './style';
//import { RootState } from '../../reducers';
import getRelativePath from '../../utils/path';
import { Box, Button, TextValidator, Typography, ValidatorForm } from '../../components';
import LoadingButton from '../../components/LoadingButton';
import { ActionStatus } from '../../constants/api';
import axios from 'axios';
import {RESET_PIN } from '../../constants/urls';

interface Props extends WithStyles<typeof Style> {
	[name: string]: any;
}

const PageEmail: React.FC<Props> = ({ classes }: Props) => {
	const navigate = useNavigate();
	const search = get(window, 'location.search', '');
	const query = new URLSearchParams(search);
	const code = query.get('code') as string;
	const client_id = query.get('client_id') as string;
	// let { code } = useParams();
	//  const code = query.get('code') as string;
	const [pinStatus, setPinStatus] = useState<ActionStatus>(ActionStatus.NONE);
	const [pin1, setPin1] = useState<string>('');
	const [pin2, setPin2] = useState<string>('');
	const [pinError, setPinError] = useState<boolean>(false);
	const [displayMessage, setDisplayMessage] = useState<string>('');
	const [actionMessage, setActionMessage] = useState<string>('');
	const Logo = getRelativePath(`images/logo.png`);

	const validateCode = (c: string, p: string) => {
		setPinStatus(ActionStatus.LOADING);
		setDisplayMessage("");
		setActionMessage("");
		axios({
			url: `${RESET_PIN}?client_id=${client_id}`,
			method: 'PUT',
			data: { code: c, pin: p },
			headers: { 'Content-Type': 'application/json' }
		})
			.then((response) => {
				setPinStatus(ActionStatus.SUCCESS);
			})
			.catch((error) => {
				setPinStatus(ActionStatus.FAILURE);
				const { response } = error;
				const status = get(response, 'status', 0);
				const display_message = get(response, 'data.display_message', '');
				const action_message = get(response, 'data.action_message', '');
				if (status >= 500) {
					setDisplayMessage('Alert!!');
					setActionMessage('Unexpected error. Please try again or contact support');
				} else {
					setDisplayMessage(display_message);
					setActionMessage(action_message);
				}
			});
	};

	useEffect(() => {
		if (code) {
			// setUrlCode(code);
			document.title = 'Enter new PIN';
		} else {
			navigate('/404', { replace: true });
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [code]);

	return (
		<div className={classes.root}>
			<div id="container" className={classes.rootBackground}>
				<img className={classes.logo} src={Logo} alt="Logo" role="presentation" />
				<Box className={classes.pageContainer}>
					<div className={classes.locklogoContainer}>
						<svg
							focusable="false"
							aria-hidden="true"
							viewBox="0 0 24 24"
							data-testid="PasswordIcon"
						>
							<path
								d="M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z"
								fill="#ffffff"
							/>
						</svg>
					</div>
					<ValidatorForm
						id="setuppinform"
						className={classes.formRoot}
						onSubmit={(e) => {}}
						onError={(e) => {}}
					>
						<Typography
							align="center"
							className={classes.title}
							style={{ fontSize: '14px', textAlign: 'center' }}
						>
							{pinStatus === ActionStatus.SUCCESS ? 'PIN SETUP' : 'Enter a new PIN'}
						</Typography>
						<Typography
							variant="h6"
							align="center"
							className={
								pinStatus === ActionStatus.SUCCESS
									? classes.titleDescriptionSuccess
									: classes.titleDescription
							}
						>
							{pinStatus === ActionStatus.SUCCESS
								? 'Your new PIN has been setup successfully.'
								: 'We may ask you for this PIN when you login. Please keep this PIN secure.'}
						</Typography>
						{pinStatus !== ActionStatus.SUCCESS && (
							<>
								<Box className={classes.pinBox1}>
									<TextValidator
										label="New PIN"
										placeholder=""
										name="pin1"
										type="password"
										value={pin1}
										onChange={(e) => {
											const value = get(e.target, 'value', '') as string;
											const onlyNums = value.replace(/[^0-9]/g, '');
											setPin1(onlyNums);
											setPinError(false);
										}}
										autoComplete="false"
										autoFocus={true}
										variant="outlined"
										margin="normal"
										InputLabelProps={{
											shrink: true
										}}
										inputProps={{
											maxLength: 4,
											style: { textAlign: 'center', letterSpacing: '6px' }
										}}
									/>
								</Box>
								<Box className={classes.pinBox2}>
									<TextValidator
										label="Verify PIN"
										placeholder=""
										type="password"
										name="pin2"
										value={pin2}
										onChange={(e) => {
											const value = get(e.target, 'value', '') as string;
											const onlyNums = value.replace(/[^0-9]/g, '');
											setPin2(onlyNums);
											setPinError(false);
										}}
										autoComplete="false"
										variant="outlined"
										margin="normal"
										InputLabelProps={{
											shrink: true
										}}
										inputProps={{
											maxLength: 4,
											style: { textAlign: 'center', letterSpacing: '6px' }
										}}
										error={pinError}
										helperText={pinError ? 'PIN mismatch' : ''}
										// onKeyPress={(ev) => {
										// 	if (ev.key === 'Enter') {
										// 		// Do code here
										// 		ev.preventDefault();
										// 		dispatch(ValidateOtp.action({ otp: otpText, nonce: loginNonce }));
										// 	}
										// }}
									/>
								</Box>
							</>
						)}
						<Box className={classes.actions}>
							<LoadingButton loading={pinStatus === ActionStatus.LOADING}>
								{pinStatus === ActionStatus.SUCCESS ? (
									// <Button
									// 	variant="contained"
									// 	className={classes.signIn}
									// 	color="primary"
									// 	type="submit"
									// 	onClick={() => {
									// 		window.opener = null;
									// 		window.open('', '_self');
									// 		window.close();
									// 	}}
									// >
									// 	Close
									// </Button>
									<></>
								) : (
									<Button
										variant="contained"
										className={classes.signIn}
										color="primary"
										disabled={
											pin1.length !== 4 ||
											pin2.length !== 4 ||
											pinStatus === ActionStatus.LOADING
										}
										onClick={() => {
											if (pin1 !== pin2) {
												setPinError(true);
											} else {
												validateCode(code as string, pin1);
											}
										}}
									>
										Submit
									</Button>
								)}
							</LoadingButton>
						</Box>

						{displayMessage && (
							<Typography className={classes.errorMessage}>{displayMessage}</Typography>
						)}
						{actionMessage && (
							<Typography className={classes.errorMessage1}>{actionMessage}</Typography>
						)}
					</ValidatorForm>
				</Box>
			</div>
		</div>
	);
};

export default generateStyle(Style, 'PageEmail')(PageEmail);
